import Icon from '../components/Icon.vue'

Icon.register({
  'pencil-ruler': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M109.5 244L244 109.5 199.9 65.4 138.2 127A7.9-7.9 0 0 0 127 127L115.8 115.8C112.7 112.7 112.7 107.7 115.8 104.6L177.5 42.9 143.9 9.3C131.5-3.1 111.4-3.1 99 9.3L9.3 99C-3.1 111.4-3.1 131.5 9.3 143.9L109.5 244zM497.9 127.2C516.7 108.5 516.7 78.1 497.9 59.3L452.7 14.1C433.9-4.7 403.5-4.7 384.7 14.1L338.7 60.1 451.9 173.3 497.9 127.2zM316.1 82.7L19.1 379.7 0.3 487.1C-2.2 501.6 10.4 514.2 24.9 511.7L132.4 492.8 429.3 195.9 316.1 82.7zM502.7 368.1L469.1 334.5 407.4 396.2C404.3 399.3 399.3 399.3 396.2 396.2L385 385C381.9 381.9 381.9 376.9 385 373.8L446.7 312.1 402.5 267.9 267.9 402.5 368.1 502.7C380.5 515.1 400.6 515.1 413 502.7L502.7 413C515.1 400.6 515.1 380.5 502.7 368.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/pencil-ruler.js
// module id = FGe4
// module chunks = 144